import PropTypes from 'prop-types';
import { Avatar, StyledSpinner } from './Styles';
import { useEffect, useState } from 'react';
import { avatarLoader } from './avatarLoader';

const LazyAvatar = ({ username }) => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    let isMounted = true;

    if (username) {
      avatarLoader
        .loadAvatar(username)
        .then((loadedUrl) => {
          if (isMounted) {
            setUrl(loadedUrl);
          }
        })
        .catch((error) => {
          if (isMounted) {
            console.error('Failed to load avatar:', error);
          }
        });
    }

    return () => {
      isMounted = false;
    };
  }, [username]);
  return (
    <Avatar style={{ backgroundImage: `url("${url}")` }}>
      {!url && <StyledSpinner animation="border" variant="light" />}
    </Avatar>
  );
};

LazyAvatar.defaultProps = {
  username: undefined,
};

LazyAvatar.propTypes = {
  username: PropTypes.string,
};

export default LazyAvatar;
